import React, { useEffect } from 'react';
import _isEmpty from 'lodash/isEmpty';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import { useDispatch, useSelector } from 'react-redux';
import SideBarListStyles from '../../styles/SideBarListStyle';
import {
  setPxDashboardSelectedUser,
  setPxDashboardSidebarList,
  showProgress,
} from '../../redux/actions/DealershipActions';
import Service from '../../apis/service';
import { ErrorToast } from '../utils/Utils';
import { apiEndpoints } from '../../constants/apiEndpoints';

export default function SidebarListPx(props) {
  const { filterArray } = props;
  const classes = SideBarListStyles();
  const dispatch = useDispatch();

  const pxUserSelected = useSelector((state) => state.pxDashboardData.selectedUser);

  const fetchDataList = async () => {
    dispatch(showProgress(true));

    try {
      const response = await Service.get(apiEndpoints.PX_OWNERS);
      dispatch(setPxDashboardSidebarList(response));
      if (!_isEmpty(response)) {
        handleListItemClick(response[0]);
      }
    } catch (err) {
      ErrorToast(err);
    }

    dispatch(showProgress(false));
  };

  useEffect(() => {
    fetchDataList();
  }, []);

  const myRefs = filterArray?.reduce((acc, val) => {
    acc[val.hash] = React.createRef();
    return acc;
  }, {});
  useEffect(() => {
    myRefs[pxUserSelected?.hash]?.current?.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    });
  }, [pxUserSelected, filterArray]);

  const handleListItemClick = async (user = {}) => {
    dispatch(showProgress(true));

    if (!_isEmpty(user)) {
      dispatch(setPxDashboardSelectedUser(user));
    }

    dispatch(showProgress(false));
  };

  return (
    <div className={classes.root}>
      <List component="nav" aria-label="secondary mailbox folder">
        {(filterArray || []).map((data) => (
          <div key={data.hash} className={pxUserSelected.hash === data.hash ? classes.highlightItem : ''}>
            <ListItem
              id={`Item${data.hash}`}
              ref={myRefs[data.hash]}
              key={data.hash}
              button
              selected={pxUserSelected.hash === data.hash}
              className={classes.listStyling}
              onClick={() => handleListItemClick(data)}
            >
              <ListItemText
                primary={
                  <div>
                    <p
                      className={`
                          ${pxUserSelected.hash === data.hash ? classes.listTextSelected : classes.listTextNonSelected}
                        `}
                    >
                      {data.name}
                    </p>
                  </div>
                }
                secondary={
                  <div>
                    <div
                      className={
                        pxUserSelected.hash === data.hash ? classes.listSubTextSelected : classes.listSubTextNonSelected
                      }
                    >
                      <div className={classes.listSubTextJustify}>
                        <div>{`${data.dealershipCount || 0} dealerships`}</div>
                      </div>
                    </div>
                  </div>
                }
              />
            </ListItem>
          </div>
        ))}
      </List>
    </div>
  );
}
